const CheckMarkSignature = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3334 2C17.8562 2 22.3334 6.47715 22.3334 12C22.3334 17.5228 17.8562 22 12.3334 22C6.81053 22 2.33337 17.5228 2.33337 12C2.33337 6.47715 6.81053 2 12.3334 2ZM12.3334 3.5C7.63895 3.5 3.83337 7.30558 3.83337 12C3.83337 16.6944 7.63895 20.5 12.3334 20.5C17.0278 20.5 20.8334 16.6944 20.8334 12C20.8334 7.30558 17.0278 3.5 12.3334 3.5ZM11.0834 13.4393L15.553 8.96967C15.8459 8.67678 16.3208 8.67678 16.6137 8.96967C16.88 9.23594 16.9042 9.6526 16.6863 9.94621L16.6137 10.0303L11.6137 15.0303C11.3474 15.2966 10.9308 15.3208 10.6372 15.1029L10.553 15.0303L8.05304 12.5303C7.76015 12.2374 7.76015 11.7626 8.05304 11.4697C8.31931 11.2034 8.73597 11.1792 9.02959 11.3971L9.1137 11.4697L11.0834 13.4393L15.553 8.96967L11.0834 13.4393Z"
        fill="#1F5C91"
      />
    </svg>
  );
};
export default CheckMarkSignature;
